React = require 'react'
ReactDnd = require 'react-dnd'
ReactDOM = require 'react-dom'
f = require 'effing'
xtend = require 'xtend'
{ BoardTile, Tile } = require './presentational/tile'

_HomeBoardDndComponent = class extends React.Component
  displayName: 'HomeBoardDndComponent'
  render: ->
    { connectDropTarget, connectDragSource, isDragging } = @props
    if isDragging
      React.createElement(Tile)
    else
      newProps = xtend @props, ref: (instance) ->
        connectDropTarget(ReactDOM.findDOMNode(instance))
        connectDragSource(ReactDOM.findDOMNode(instance))
      React.createElement(BoardTile, newProps)

dropSpec =
  canDrop: ->
    false
  hover: (props, monitor) ->
    if props.id != monitor.getItem().id
      props.onDragHover(monitor.getItem().id)

dropCollect = (connect, monitor) ->
  connectDropTarget: connect.dropTarget()

dragSpec =
  beginDrag: (props) ->
    id: props.id
  endDrag: (props) ->
    props.onDragEnd()

dragCollect = (connect, monitor) ->
  connectDragSource: connect.dragSource()
  isDragging: monitor.isDragging()

module.exports = ReactDnd.DragSource('HomeBoardTile', dragSpec, dragCollect)(ReactDnd.DropTarget('HomeBoardTile', dropSpec, dropCollect)(_HomeBoardDndComponent))



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-board-dnd-component.coffee